import { useState, useEffect } from "react";
import { v4 as uuidv4 } from "uuid";
import { CheckCircle, XCircle } from "lucide-react";

let showToast = () => { };

const Toast = ({ message, type, details, duration, onClose }) => {
    const [progress, setProgress] = useState(100);
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        setVisible(true);

        const intervalTime = 50;
        const decrement = (100 / (duration / intervalTime));

        const interval = setInterval(() => {
            setProgress((prev) => Math.max(prev - decrement, 0));
        }, intervalTime);

        const timer = setTimeout(() => {
            setVisible(false);
            setTimeout(onClose, 300);
        }, duration);

        return () => {
            clearTimeout(timer);
            clearInterval(interval);
        };
    }, [onClose, duration]);

    return (
        <div
            className={`relative flex items-start gap-3 w-96 max-w-sm px-4 py-3 rounded-lg shadow-xl text-white transition-all duration-300 transform
            ${visible ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-4"}
            ${type === "success" ? "bg-green-600" : "bg-red-600"}`}
            style={{ zIndex: 50 }}
        >
            {type === "success" ? (
                <CheckCircle className="w-6 h-6 text-white opacity-80" />
            ) : (
                <XCircle className="w-6 h-6 text-white opacity-80" />
            )}

            <div className="flex-1">
                <strong className="block">{message}</strong>
                {details && <p className="text-sm opacity-80">{details}</p>}
            </div>

            <div
                className="absolute bottom-0 left-0 h-1 rounded bg-white opacity-50 transition-all"
                style={{ width: `${progress}%` }}
            ></div>
        </div>
    );
};

const ToastContainer = () => {
    const [toasts, setToasts] = useState([]);

    showToast = (message, type = "success", duration = 3000, details = "") => {
        const id = uuidv4();
        setToasts((prevToasts) => [...prevToasts, { id, message, type, duration, details }]);
        setTimeout(() => {
            setToasts((prev) => prev.filter((toast) => toast.id !== id));
        }, duration + 300);
    };

    return (
        <div className="fixed top-5 right-5 space-y-3" style={{ zIndex: 50 }}>
            {toasts.map((toast) => (
                <Toast
                    key={toast.id}
                    message={toast.message}
                    type={toast.type}
                    duration={toast.duration}
                    details={toast.details}
                    onClose={() => setToasts((prev) => prev.filter((t) => t.id !== toast.id))}
                />
            ))}
        </div>
    );
};

export { ToastContainer, showToast };
